import { type CodeFormat } from "../code-formats";
import { type CodePattern } from "../code-patterns";

import { validateChildId } from "./validate-child-id";
import { validateOrderId } from "./validate-order-id";
import { validateFormat } from "./validate-format";

export type CodeValidationResult = {
  format: CodeFormat;
  patterns: CodePattern[];
  value: string;
};

/**
 * Validates a scanned code and determines its type.
 *
 * @param {string} code - The scanned code to validate.
 * @returns {CodeValidationResult | null} An object containing the validated code and its type, or null if the code is invalid.
 *
 * The function checks the scanned code against different patterns.
 * If the scanned code does not match any of the above patterns, the function returns null.
 */
export function validate(code: string): CodeValidationResult | null {
  const orderIdResult = validateOrderId(code);
  if (orderIdResult) {
    return orderIdResult;
  }

  const childIdResult = validateChildId(code);
  if (childIdResult) {
    return childIdResult;
  }

  const result = validateFormat(code);
  if (result) {
    return result;
  }

  return null;
}
